
<div *ngIf="!showAccountProfile && !showAccountPassword">
    <div class="leftCard" >
        <mat-card  style="padding: 15px">
                <div class="titleFont" style="padding-bottom: 10px; padding-top: 20px; padding-left: 15px; text-align: left">Personal Details</div>
                <div class="smallerFont" style="text-align: left; padding-bottom: 15px; padding-left: 15px;font-size: 17px;">Update your profile information including your email, phone or address.</div>
                <div class="smallerFont" (click)="showProfile()" style="text-align: left; padding-bottom: 15px; padding-left: 15px;font-size: 17px; cursor: pointer"><a style="color: #005999; text-decoration:underline">Update Info></a></div>
        </mat-card>
    </div>
    <div class="rightCard">
    <mat-card style="padding: 15px" >
      <div class="titleFont" style="padding-bottom: 10px; padding-top: 20px; padding-left: 15px; text-align: left">Sign-in & Security</div>
      <div class="smallerFont" style="text-align: left; padding-bottom: 15px; padding-left: 15px;font-size: 17px;">Update your password to one that is unique to this account.</div>
      <div class="smallerFont" (click)="showPasswordPage()" style="text-align: left; padding-bottom: 15px; padding-left: 15px;font-size: 17px; cursor: pointer"><a style="color: #005999; text-decoration:underline">Update Password></a></div>
    </mat-card>
    </div>
</div>

<div  *ngIf="showAccountProfile" style="text-align: -webkit-center;text-align: -moz-center; height: 85vh">
  <mat-card class="speech-bubble">
    <div class="maher" (click)="myApp.showCharts()"></div>
    <table style="width: 100%; padding: 0px; margin: 0px">
      <tr>
        <td class="upperTd"  >
          <div class="maherlogo"></div>
          <div class="account"></div>
          <div class="titleFont" style="padding-bottom: 10px; padding-top: 38px; text-align: center">Account Profile</div>
          <div class="smallerFont" style="text-align: center; padding-bottom: 15px">All Fields Marked With <mat-icon matSuffix><img style="vertical-align: center;" src="assets/check_circle-24px.svg" ></mat-icon> Are Required Fields</div>

          <form  [formGroup]="myForm" autocomplete="off"   novalidate>


            <div class="two-col">
              <div class="col1">
                <mat-form-field appearance="outline" style="width: 90%">
                  <mat-label>Username</mat-label>
                  <input maxlength="30" oninput="this.value = this.value.toUpperCase()" matInput readonly formControlName="username" />
                </mat-form-field>
              </div>
              <div class="col2">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Email Address</mat-label>

                  <input maxlength="50"  matInput formControlName="email" />
                  <mat-icon matSuffix *ngIf="f.email.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.email.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.email.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.email.errors.required && submitted">Email Address Required</div>
                </span>
              </div>
              </div>






            <div class="two-col">

              <div class="col1">
                <mat-form-field appearance="outline" style="width: 90%; ">
                  <mat-label>First Name</mat-label>
                  <input maxlength="30"  matInput formControlName="firstName" />
                  <mat-icon matSuffix *ngIf="f.firstName.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.firstName.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.firstName.errors" class="invalid-feedback" >
                     <div class="errorDiv2"  *ngIf="f.firstName.errors.required && submitted">First Name Required</div>
                </span>
              </div>

              <div class="col2">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Last Name</mat-label>
                  <input maxlength="30"  matInput formControlName="lastName" />
                  <mat-icon matSuffix *ngIf="f.lastName.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.lastName.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.lastName.errors" class="invalid-feedback" >
                  <div class="errorDiv2"  *ngIf="f.lastName.errors.required && submitted">Last Name Required</div>
                </span>
              </div>

            </div>




            <div class="two-col">

              <div class="col1">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Phone Number: (999) 999-9999</mat-label>

                  <input matInput id="tel" phoneMask [preValue]="myForm.value.phone"  [phoneControl]="myForm.controls['phone']" formControlName="phone" maxlength="14"  [disabled]="submitted" />
                  <mat-icon matSuffix *ngIf="f.phone.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.phone.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.phone.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.phone.errors.required && submitted">Phone Number Required</div>
                </span>
              </div>

              <div class="col2">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Fax Number: (999) 999-9999</mat-label>
                  <input matInput id="tel1" phoneMask [preValue]="myForm.value.fax"  [phoneControl]="myForm.controls['fax']" formControlName="fax" maxlength="14"  [disabled]="submitted" />
                </mat-form-field>
              </div>

              <div class="col1" *ngIf="myUser.role=='MISC' && myUser.company_code=='M0995'">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Sealink</mat-label>
                  <input matInput   formControlName="sealink" maxlength="7"  [disabled]="submitted" />
                  <mat-icon matSuffix *ngIf="f.sealink.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.sealink.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.sealink.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.sealink.errors.required && submitted">Sealink Required</div>
                </span>
              </div>


            </div>


            <table style="width: 100%">
              <tr>
                <td style="alignment: center">
                  <div class="errorDiv2" style="font-size: 20px" *ngIf="navisErrors!=''">{{navisErrors}}</div>
                  <div class="errorDiv2" style="font-size: 20px" *ngIf="maherError!=null">{{maherError}}</div>
                </td>
              </tr>
            </table>


          </form>
          <div style="padding-top: 5%; text-align: center; padding-bottom: 30px">
            <div class="two-col">
              <div class="col1" style="text-align: right; max-width: 48%">
                <button mat-raised-button class="blueButton"  (click)="createUpdateNewUser('F')" style="width: 80%" color="primary">Save</button>
              </div>
              <div class="col2" style="text-align: left; max-width: 48%">
                <button mat-raised-button class="redButton"  (click)="returnToChoice()" style="width: 80%;" color="primary">Cancel</button>
              </div>
            </div>
          </div>
        </td>

        <td class="daPic" style="width: 10%;  height: 100%;  vertical-align: top;">
        </td>
      </tr>
    </table>
  </mat-card>
</div>


  <div  *ngIf="showAccountPassword && !phoneApp" style="text-align: -webkit-center; text-align: -moz-center;height: 85vh">
    <mat-card class="speech-bubble2" >
      <div class="maher" (click)="myApp.showCharts()"></div>

      <table style="width: 100%; padding: 0px; margin: 0px">
        <tr>
          <td class="upperTd"  >
            <div class="maherlogo"></div>
            <div class="account"></div>
            <div class="titleFont" style="padding-bottom: 10px; padding-top: 20px; text-align: center">Change Password</div>

      <form  [formGroup]="myForm2" autocomplete="off"   novalidate>

      <table style="width: 100%; padding: 0px; margin: 0px">
        <tr>
          <td style="text-align: left; width: 100%; padding-left: 40px" colspan="2">
              <mat-label [className]="passFields? 'redText':'greenText'">Current Password</mat-label>
                <div>
              <mat-form-field appearance="outline"   class="currentPassword" >
                <input maxlength="20" placeholder="Please enter your current password first"  [type]="activePass ? 'password' : 'text'"  matInput formControlName="oldPassword"   />
                <a matSuffix matTooltip="show/hide password" (click)="showPassword()" style="font-size: 13px; cursor: pointer">
                  <a *ngIf="activePass" style="padding-right: 10px">SHOW </a>
                  <a *ngIf="!activePass" style="padding-right: 10px">HIDE </a>
                </a>

              </mat-form-field>
              <button mat-raised-button class="blueButton"  (click)="checkOldPassword()" style="padding-top: 8px;" ><img style="height: 33px; vertical-align: sub"  src="assets/search.png" ></button>
            <div class="errorDiv2" style="font-size: 14px" *ngIf="badPassword ">Current Password is Incorrect</div>
                </div>

          </td>
        </tr>


        <tr >
          <td style="text-align: left; width: 55%; padding-left: 40px" >
            <div style="padding-top: 25px"></div>
            <mat-label [className]="passFields? 'greyText':'blackText'" >New Password</mat-label>
            <div>
            <mat-form-field appearance="outline" style="width: 100%"   >
              <input maxlength="20"  placeholder="Follow rules on the right" (keyup)="checkRules()"  [type]="activeNewPass ? 'password' : 'text'" matInput formControlName="newPassword"/>
              <div matSuffix matTooltip="show/hide password" (click)="showNewPassword()"  style="font-size: 13px;cursor: pointer" >
                <a *ngIf="activeNewPass && !passFields" >SHOW </a>
                <a *ngIf="!activeNewPass && !passFields">HIDE </a>
              </div>

            </mat-form-field>
            </div>
            <mat-label [className]="passFields? 'greyText':'blackText'" >Confirm New Password</mat-label>
            <div>
            <mat-form-field appearance="outline" style="width: 100%" >
              <input maxlength="20" placeholder="Repeat it just to be safe" [type]="activeConfirm ? 'password' : 'text'" matInput formControlName="newConfirm"/>
              <div matSuffix matTooltip="show/hide password" (click)="showConfirmPassword()"  style="font-size: 13px;cursor: pointer">
                <a *ngIf="activeConfirm && !passFields">SHOW </a>
                <a *ngIf="!activeConfirm && !passFields">HIDE </a>
              </div>
            </mat-form-field>
            <div class="errorDiv2" style="font-size: 14px" *ngIf="disableSubmit && submitted">Confirm Password Doesn't Match</div>
            </div>
          </td>
          <td style="text-align: -webkit-center; vertical-align: bottom;text-align: -moz-center;">
            <div style="background-color:#efefef;text-align: left; padding-top: 15px; width: 88%">
              <div style="font-weight: bolder; font-size: 16px; text-align: center">Your new password must contain at least:</div>
              <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="totalFound>5 ? 'assets/greenCheck.png': 'assets/troubleRed.png'"  ></mat-icon>5 or More Characters</div>
              <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="lowerFound>2 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>3 Lowercase letters</div>
              <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="numberFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Number</div>
              <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center;height: 17px" [src]="strangeFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Special Character</div>
            </div>

          </td>

        </tr>
        <tr>
          <td colspan="2" >
            <div style="padding-top: 2%; text-align: center; padding-bottom: 15px">
              <div class="two-col">
                <div class="col1" style="text-align: right">
                  <button mat-raised-button class="blueButton"  (click)="createUpdateNewUser('P')" style="width: 46%" color="primary" [disabled]="passFields">Save Password</button>
                </div>
                <div class="col1" style="text-align: left; padding-left: 15px">
                  <button mat-raised-button class="redButton"  (click)="returnToChoice()" style="width: 46%;" color="primary">Cancel</button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
      </form>
          </td>

          <td class="daPic" style="width: 10%;  height: 100%;  vertical-align: top;">
        </tr>
      </table>
    </mat-card>
  </div>


<div  *ngIf="showAccountPassword && phoneApp" style="text-align: -webkit-center; text-align: -moz-center;height: 85vh">
  <mat-card class="speech-bubble2" >
    <div class="maher" (click)="myApp.showCharts()"></div>

    <table style="width: 100%; padding: 0px; margin: 0px">
      <tr>
        <td class="upperTd"  >
          <div class="maherlogo"></div>
          <div class="account"></div>
          <div class="titleFont" style="padding-bottom: 10px; padding-top: 40px; text-align: center">Change Password</div>

          <form  [formGroup]="myForm2" autocomplete="off"   novalidate>

            <table style="width: 100%; padding: 0px; margin: 0px">
              <tr>
                <td style="text-align: left; width: 100%; " >
                  <div>
                    <mat-form-field appearance="outline"   class="currentPassword"  floatLabel="always">
                      <mat-label >Current Password</mat-label>
                      <input maxlength="20"    matInput formControlName="oldPassword"  [type]="activePass ? 'password' : 'text'" />
                      <a matSuffix matTooltip="show/hide password" (click)="showPassword()" style="font-size: 13px; cursor: pointer">
                        <a *ngIf="activePass" >SHOW </a>
                        <a *ngIf="!activePass" >HIDE </a>
                      </a>

                    </mat-form-field>
                    <button mat-raised-button class="blueButton"  (click)="checkOldPassword()" style="padding-top: 8px;" ><img style="height: 33px; vertical-align: sub"  src="assets/search.png" ></button>
                    <div class="errorDiv2" style="font-size: 14px" *ngIf="badPassword ">Current Password is Incorrect</div>
                  </div>

                </td>
              </tr>


              <tr >
                <td style="text-align: left; width: 100%;" >
                    <mat-form-field appearance="outline" style="width: 100%"   floatLabel="always">
                      <mat-label >New Password</mat-label>
                      <input maxlength="20"   (keyup)="checkRules()"  [type]="activeNewPass ? 'password' : 'text'" matInput formControlName="newPassword"/>
                      <div matSuffix matTooltip="show/hide password" (click)="showNewPassword()"  style="font-size: 13px;cursor: pointer" >
                        <a *ngIf="activeNewPass && !passFields" >SHOW </a>
                        <a *ngIf="!activeNewPass && !passFields">HIDE </a>
                      </div>
                    </mat-form-field>
                </td>
                <tr>
              <td style="text-align: left; width: 100%;" >
                  <div>
                    <mat-form-field appearance="outline" style="width: 100%" floatLabel="always">
                      <mat-label >Confirm New Password</mat-label>
                      <input maxlength="20"  [type]="activeConfirm ? 'password' : 'text'" matInput formControlName="newConfirm"/>
                      <div matSuffix matTooltip="show/hide password" (click)="showConfirmPassword()"  style="font-size: 13px;cursor: pointer">
                        <a *ngIf="activeConfirm && !passFields">SHOW </a>
                        <a *ngIf="!activeConfirm && !passFields">HIDE </a>
                      </div>
                    </mat-form-field>
                    <div class="errorDiv2" style="font-size: 14px" *ngIf="disableSubmit && submitted">Confirm Password Doesn't Match</div>
                  </div>
                </td>
            </tr>
              <tr>
                <td style="text-align: -webkit-center; vertical-align: bottom;text-align: -moz-center;">
                  <div style="background-color:#efefef;text-align: left; padding-top: 15px; width: 100%; border: #E61E00 solid 1px">
                    <div style="font-weight: bolder; font-size: 16px; text-align: center">Your new password must contain at least:</div>
                    <div style="padding-left: 25%; padding-bottom: 20px;">
                    <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="totalFound>5 ? 'assets/greenCheck.png': 'assets/troubleRed.png'"  ></mat-icon>5 or More Characters</div>
                    <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="lowerFound>2 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>3 Lowercase letters</div>
                    <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="numberFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Number</div>
                    <div class="rules"><mat-icon matPrefix ><img style="vertical-align: center;height: 17px" [src]="strangeFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Special Character</div>
                    </div>

                  </div>

                </td>

              </tr>
              <tr>
                <td colspan="2" >
                  <div style="padding-top: 2%; text-align: center; padding-bottom: 15px">
                    <div class="two-col">
                      <div class="col1" style="text-align: right; width: 48%">
                        <button mat-raised-button class="blueButton"  (click)="createUpdateNewUser('P')" style="width: 95%" color="primary" [disabled]="passFields">Save Password</button>
                      </div>
                      <div class="col2" style="text-align: left; width: 48%">
                        <button mat-raised-button class="redButton"  (click)="returnToChoice()" style="width: 95%;" color="primary">Cancel</button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </form>
        </td>

        <td class="daPic" style="width: 10%;  height: 100%;  vertical-align: top;">
      </tr>
    </table>
  </mat-card>
</div>

